import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { GetOrgAccountSummaryReturn as PaymentAccountSummary, getOrgId, OrganizationId } from "api";
import { Credentials } from "auth";
import { State } from "redux/state";

export type FetchPaymentAccountSummary = "FETCH_PAYMENT_ACCOUNT_SUMMARY";
export const FETCH_PAYMENT_ACCOUNT_SUMMARY: FetchPaymentAccountSummary = "FETCH_PAYMENT_ACCOUNT_SUMMARY";
export type FetchPaymentAccountSummaryEnd = "FETCH_PAYMENT_ACCOUNT_SUMMARY_END";
export const FETCH_PAYMENT_ACCOUNT_SUMMARY_END: FetchPaymentAccountSummaryEnd = "FETCH_PAYMENT_ACCOUNT_SUMMARY_END";

export interface FetchPaymentAccountSummaryAction extends Action {
    payload: {
        credentials: Credentials;
        organizationId: string;
    };
    type: FetchPaymentAccountSummary;
}

export function fetchPaymentAccountSummary(
    organization: OrganizationId
): ThunkAction<void, State, undefined, FetchPaymentAccountSummaryAction> {
    return (dispatch: Dispatch<FetchPaymentAccountSummaryAction>, getState) => {
        const state = getState();
        dispatch(fetchPaymentAccountSummaryWithCredentials(organization, state.auth.credentials));
    };
}

export function fetchPaymentAccountSummaryWithCredentials(organization: OrganizationId, credentials: Credentials) {
    const organizationId = getOrgId(organization);
    return {
        payload: {
            credentials,
            organizationId
        },
        type: FETCH_PAYMENT_ACCOUNT_SUMMARY
    };
}

export interface FetchPaymentAccountSummaryEndAction extends Action {
    payload: {
        accountSummary?: PaymentAccountSummary;
        error?: Error;
        organizationId: string;
    };
    type: FetchPaymentAccountSummaryEnd;
}

export function fetchPaymentAccountSummaryEnd(
    error: Error,
    organization: OrganizationId,
    accountSummary?: PaymentAccountSummary
): FetchPaymentAccountSummaryEndAction {
    const organizationId = getOrgId(organization);

    return {
        payload: {
            accountSummary,
            error,
            organizationId
        },
        type: FETCH_PAYMENT_ACCOUNT_SUMMARY_END
    };
}
